import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { AddTaskFormFields, AddTaskHandlersProps } from "@/modules/tasks/types";
import { combineDateAndTime } from "@/modules/tasks/utils";

export const useAddTaskHandlers = ({
  mutationAddTask,
  setValueAddTask,
  setDueDate,
  setSelectedTime,
  selectedTime,
  dueDate,
}: AddTaskHandlersProps) => {
  // ===== SUBMIT HANDLER =====
  const onSubmitAddTask: SubmitHandler<AddTaskFormFields> = useCallback(
    (data) => {
      // Remove selectedTime from the data before sending to API
      const { selectedTime: _, ...submitData } = data;
      mutationAddTask.mutate(submitData);
    },
    [mutationAddTask]
  );

  // ===== DATE & TIME HANDLERS =====
  const updateFormDueDate = useCallback(
    (dateObj: Date | null, time: string) => {
      if (!dateObj) {
        setValueAddTask("dueDate", "");
        return;
      }
      const combinedDateTime = combineDateAndTime(dateObj, time);
      setValueAddTask("dueDate", combinedDateTime?.toISOString() || "");
    },
    [setValueAddTask]
  );

  const handleDateChange = useCallback(
    (date: string | Date | null) => {
      const dateObj =
        date instanceof Date ? date : date ? new Date(date) : null;
      setDueDate(dateObj);
      updateFormDueDate(dateObj, selectedTime);
    },
    [setDueDate, updateFormDueDate, selectedTime]
  );

  const handleTimeChange = useCallback(
    (time: string) => {
      setSelectedTime(time);
      setValueAddTask("selectedTime", time);
      updateFormDueDate(dueDate, time);
    },
    [dueDate, setSelectedTime, setValueAddTask, updateFormDueDate]
  );

  // ===== RETURN HANDLERS =====
  return {
    onSubmitAddTask,
    handleDateChange,
    handleTimeChange,
  };
};
